import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  notification,
  Radio,
  RadioChangeEvent,
} from "antd";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  EMAIL,
  KEYROCK_TOKEN,
  PUBLICIP
} from "../../../utils/constants";
import { signInApi, Keyrock ,getUserRol} from "../../../api/user";
 
import { post } from "../../../api/post";

import "./LoginForm.scss";


export default function LoginForm() {
  //Creamos unos hooks para guardar el estado del formulario
  const [rol,setRol]=useState('')
  const [circular, setcircular] = useState(false);
  const [inputs, setInputs] = useState({
    /* email: "741435@unizar.es",
    password: "123456",
    idp: "EU.EORI.ESCAPILLAR", */
    email: "",
    password: "",
    idp: "",
  });
  const [value, setValue] = useState(1);
  //Cuando haya cambios debe actualizar el estado
  const changeForm = (e) => {
    // console.log(e)
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });

    /* setInputs({
      email: "741435@unizar.es",
      password: "123456",
      idp: e.target.value,
    }); */
   
  };

  function resetPass(){
    window.location.href = "/reset";
  }

  const login = async (e) => {
    setcircular(true)
    const result = await post(inputs,'sign-in','sign-in','');
   //console.log('result',result.message)
   var publicIP;
    try {
      try{
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        publicIP=data.ip
        console.log('PublicIP: ',publicIP)
      }catch(e){
        publicIP=inputs.email
      }
    
  
    //El backend devuelve message si ha habido algún error por eso este primer if
    if (result.message) {
      notification["error"]({
        message: 'Login error. Check your user and password.',
      });
      setcircular(false)
    } else {
      const { accessToken, refreshToken } = result;
      //Almacenamos en local la informacion del access token y del refresh token
      localStorage.clear()
      localStorage.setItem(ACCESS_TOKEN, accessToken);
      localStorage.setItem(REFRESH_TOKEN, refreshToken);
      localStorage.setItem(EMAIL, inputs.email);
      localStorage.setItem(PUBLICIP, publicIP); 
      var role=await getUserRol(accessToken);
      setRol(role)
      notification["success"]({
        message: "Login correcto.",
      });
      //Redirigimos al admin
      //console.log(basePath)
      window.location.href = "/admin";
     /*  Keyrock(inputs.idp).then((res) => {
        localStorage.setItem(KEYROCK_TOKEN, res);
        window.location.href = res;
      }); */
      setcircular(false)
    }
    } catch (error) {
      setcircular(false)
      console.error(error);
      notification["error"]({
        message: error,
      });
    }
  };

  return (
    <>
    <Form className="login-form" onChange={changeForm} onFinish={login}>
     <Form.Item>
        <Input
          //prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
          type="email"
          name="email"
          placeholder="Correo electronico"
          className="login-form__input"
        />
      </Form.Item>
      <Form.Item>
        <Input
          //prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
          type="password"
          name="password"
          placeholder="Contraseña"
          className="login-form__input"
        />
      </Form.Item> 
      {/* <Form.Item>
        <Radio.Group name="idp" type="idp" label="idp" className="login-form__form" >
          <Radio value={"EU.EORI.ESCAPILLAR"}>CapillarIT IDP</Radio>
          <Radio value={"EU.EORI.BELURBIKE22"}>URBIKE IDP</Radio>
        </Radio.Group>
      </Form.Item>
      <br></br> */}
      <Form.Item>
        {(circular)?<Button id={'login-boton'} disabled={true}  style={{
                    backgroundColor:'rgb(220,220,220)',
                    borderWidth:'2px',
                    fontSize:'22px',
                    borderColor:'grey',
                    color:'grey',
                    fontFamily:'report'
                  }} type="primary" htmlType="submit" className="login-form__button">
          Entrar
        </Button>
        :<Button id={'login-boton'}  type="primary" style={{
          color:'rgb(35,148,212)',
          fontFamily:'report',
          backgroundColor:'rgb(211, 232, 245)',
          borderWidth:'2px',
          fontSize:'22px',
          borderColor:'rgb(35,148,212)',
        }} htmlType="submit" className="login-form__button">
          Entrar
        </Button>}
        {(circular)
        ?<div className="holas" style={{display:'flex', justifyContent:'center'}}>
          <div className="cargandoOutput">
          
          </div>
          <div className="" style={{paddingLeft:'20px',paddingTop:'10px'}}>
          <h3 >Comprobando credenciales</h3>
          
          </div>
        </div>
      :<div className="vacioOutput">
        </div>}
      </Form.Item>
    </Form>
    <div 
      onClick={()=>resetPass()}
      style={{cursor:'pointer',marginTop: '15px', color: 'rgb(35,148,212)', fontFamily: 'report', textDecoration: 'underline',fontSize:'17px'}}>
      ¿Has olvidado tu contraseña?
    </div>
    </>
  );
}
